export enum FundGoals {
  WidowsAndOrphans = 'WidowsAndOrphans',
  BrideHelp = 'BrideHelp',
  Medicine = 'Medicine',
  Disasters = 'Disasters',
  Debts = 'Debts',
  DifficultFinancialSituation = 'DifficultFinancialSituation',
  Other = 'Other',
  OperationIronSwords = 'OperationIronSwords',
  FamilySupport = 'FamilySupport',
  KollelSupport = 'KollelSupport',
  CommunityExpenses = 'CommunityExpenses',
}
